/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Synthflow Backend
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type AssistantBackgroundNoiseType =
  | (typeof AssistantBackgroundNoiseType)[keyof typeof AssistantBackgroundNoiseType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssistantBackgroundNoiseType = {
  office: "office",
  cafe: "cafe",
} as const;
